import type { ViewController } from '@presentation/shell/NexxusShell';
import { listConges } from '@application/rh/CongesDirectoryService';
import {
  buildPilotageAlerts,
  computePilotageKpis,
  type PilotageAlertGravite,
} from '@domain/rh/PilotageRhAlerts';
import { esc, fmtDate } from '@presentation/shell/format';
import { tenantIdOf } from '@presentation/shell/localCrud';

function kpi(label: string, value: string | number): string {
  return `<div class="kpi"><div class="label">${label}</div><div class="value">${value}</div></div>`;
}

function gravitePill(g: PilotageAlertGravite): string {
  if (g === 'URGENT') return '<span class="pill danger">Urgent</span>';
  if (g === 'ATTENTION') return '<span class="pill warning">Attention</span>';
  return '<span class="pill">Info</span>';
}

function joursLabel(j: number): string {
  if (j < 0) return `J${j}`;
  if (j === 0) return "Aujourd'hui";
  return `J+${j}`;
}

export const pilotageController: ViewController = async (section, ctx) => {
  const tid = tenantIdOf(ctx);
  const [salaries, conges] = await Promise.all([ctx.salaries.list(), listConges(tid)]);
  const alerts = buildPilotageAlerts(salaries, conges);
  const kpis = computePilotageKpis(salaries, alerts);

  const grid = section.querySelector('#pilotage-kpi-grid');
  if (grid) {
    grid.innerHTML =
      kpi('Effectif actif', kpis.effectif) +
      kpi('CDD ≤ 60 j', kpis.cddExpiring) +
      kpi('Essai ≤ 30 j', kpis.essaiEnding) +
      kpi('Visites médicales', kpis.visitesMedicales) +
      kpi('Séjour ≤ 90 j', kpis.sejourExpiring);
  }

  const tbody = section.querySelector('#pilotage-alerts-table tbody');
  if (tbody) {
    tbody.innerHTML =
      alerts.length === 0
        ? '<tr><td colspan="5" style="color:var(--gris);padding:14px;">Aucune alerte à signaler.</td></tr>'
        : alerts
            .map(
              (a) => `<tr>
          <td>${esc(a.type)}<div style="font-size:11px;color:var(--gris);margin-top:2px;">${esc(a.message)}</div></td>
          <td><strong>${esc(a.salarie_label)}</strong></td>
          <td>${esc(fmtDate(a.echeance))}</td>
          <td class="num">${esc(joursLabel(a.jours))}</td>
          <td>${gravitePill(a.gravite)}</td>
        </tr>`,
            )
            .join('');
  }
};
